<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import flashMessage from "../../components/flashMessahe";
import VueSweetalert2 from "vue-sweetalert2";
import ErrorMessage from "../../components/error-message";
import {
  required,
  email,
  minLength,
  sameAs,
  maxLength,
  minValue,
  maxValue,
  numeric,
  url,
  alphaNum,
} from "vuelidate/lib/validators";

export default {
  components: {
      ErrorMessage,
    Layout,
    PageHeader,
    flashMessage,
  },
  data() {
    return {
      errorMessage: "",
      title: "Role Create",
      items: [
        {
          text: "Role",
          href: "/",
        },
        {
          text: "Create",
          active: true,
        },
      ],
      status: "not_accepted",
      checkCustom: "not_accepted",
      checked: true,
      errors: null,
        visible:false,
        message:"",
      form: {
        role_name: "",
        role_type: "",
      },
      submitform: false,
      submitted: false,
    };
  },
  validations: {
    form: {
      role_name: {
        required,
      },
      role_type: {
        required,
      },
    },
  },
  methods: {
      onClose(){
          this.visible=false;
      },
    formSubmit(event) {
      this.submitted = true;
      this.$v.$touch();
      axios
        .post("/api/role_add", {
          name: this.form.role_name,
          type: this.form.role_type,
          accessToken: localStorage.getItem("access_tocken"),
        })
        .then((response) => {
          if (response.data.status) {
            this.$refs.roleEntryForm.reset();
             this.$swal("Role Created", "success");
            this.$router.push({ name: "all_role" });
          } else {
            var str = response.data.message;
            var jsonParse = JSON.parse(str);
            this.errorCheck(jsonParse);
          }
        })
        .catch((error) => {
          if (error.response != undefined) {
            this.errors = error.response.data.errors;
          }
        });
    },
    errorCheck(obj) {
      if (obj.error) {
        this.errors = obj.message;
          this.visible=true;
          this.message="Access Permission Denied";
      } else if (obj.message == "Token has expired") {
          this.$swal.fire({
              title: 'LogOut!',
              text: 'Token Has Expired',
              icon: 'error',
              toast:'true',
              position: 'top-end',
          });
        this.$router.push({ name: "logout" });
      } else if (
        obj.message !== "Token has expired" &&
        obj.message !== "The given data was invalid."
      ) {
        this.errors = obj.message;
      } else if (obj.message == "The given data was invalid.") {
        this.errors = obj.errors;
      } else {
        this.flashMessage.show({
          time: 5000,
          status: "error",
          title: "Error",
          message: "Problem in data save",
        });
      }
    },
    resetForm(event) {
      // console.log("Reseting the form");
      event.target.reset();
    },
  },
};
</script>

<template>
  <Layout>
    <flashMessage/>
    <PageHeader :title="title" :items="items" />
      <ErrorMessage :visible="visible" :errors="errors" v-on:close="onClose" :message="message"/>
    <div class="row">
      <div class="col-lg-12 col-sm-12">
        <div class="card">
          <div class="card-body">
<!--            <div v-if="errors" class="font-bold mb-4 ">-->
<!--              <div v-for="(v, k) in errors" :key="k">-->
<!--                <p v-for="error in v" :key="error" class="text-sm">-->
<!--                  {{ error }}-->
<!--                </p>-->
<!--              </div>-->
<!--            </div>-->
            <b-form class="needs-validation" ref="roleEntryForm" @submit.prevent="formSubmit">
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label class="required" for="role_name">Role Name</label>
                    <input
                      id="role_name"
                      v-model="form.role_name"
                      name="role_name"
                      type="text"
                      class="form-control"
                      placeholder="Type role name"
                      value
                      :class="{ 'is-invalid': submitted && $v.form.role_name.$error }"
                    />
                    <div
                      v-if="submitted && $v.form.role_name.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.form.role_name.required">This value is required.</span>
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-group">
                    <label class="required" for="role_type">Role Type</label>
                      <select
                          id="role_type"
                          v-model="form.role_type"
                          name="role_type"
                          type="text"
                          class="form-control"
                          placeholder="Type role name"
                          value
                          :class="{ 'is-invalid': submitted && $v.form.role_type.$error }">
                          <option value="" disabled style="display:none" selected>Select Role Type</option>
                          <option value="admin">Admin</option>
                          <option value="b2b">B2B</option>
                          <option value="b2c">B2C</option>
                      </select>
                    <div
                      v-if="submitted && $v.form.role_type.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.form.role_type.required">This value is required.</span>
                    </div>
                  </div>
                </div>
              </div>
              <button class="btn btn-primary" type="submit">Submit</button>
            </b-form>
          </div>
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>
